import { State } from '../../type'
import { moduleName } from './constants'
import { IILedByGPOState } from './types'

const getState = (state: State): IILedByGPOState => state[moduleName]

export const getList = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.list
}

export const getSearch = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.search
}

export const getTotal = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.total
}

export const getIsLoading = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.isLoading
}
